import { Table, TableCard } from "@/components/application/table/table";
import { type CategoryComparisonRow, CHART_COLORS, QUALITY_BAND_COLORS } from "../flag-qa-types";
import { getQualityBand } from "../flag-qa-utils";

interface FlagQaCategoryComparisonProps {
  data: CategoryComparisonRow[];
}

export function FlagQaCategoryComparison({ data }: FlagQaCategoryComparisonProps) {
  if (data.length === 0) return null;

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4 text-primary">Category Comparison (Current - Previous) - F1 Ranked</h3>
      <TableCard.Root>
        <div className="overflow-x-auto">
          <Table>
            <Table.Header>
              <Table.Head id="category" label="Category" isRowHeader />
              <Table.Head id="f1A" label="F1 % (Current)" />
              <Table.Head id="f1B" label="F1 % (Previous)" />
              <Table.Head id="f1Delta" label="F1 Delta" />
            </Table.Header>
            <Table.Body items={data}>
              {(row) => (
                <Table.Row id={row.category}>
                  <Table.Cell>{row.category}</Table.Cell>
                  <Table.Cell>
                    <span style={{ color: QUALITY_BAND_COLORS[getQualityBand(row.f1A)] }}>{row.f1A.toFixed(1)}%</span>
                  </Table.Cell>
                  <Table.Cell>
                    <span style={{ color: QUALITY_BAND_COLORS[getQualityBand(row.f1B)] }}>{row.f1B.toFixed(1)}%</span>
                  </Table.Cell>
                  <Table.Cell>
                    <span
                      className="font-semibold"
                      style={{
                        color:
                          row.f1Delta > 0
                            ? CHART_COLORS.positive
                            : row.f1Delta < 0
                              ? CHART_COLORS.negative
                              : CHART_COLORS.neutral,
                      }}
                    >
                      {row.f1Delta > 0 ? "+" : ""}
                      {row.f1Delta.toFixed(1)}%
                    </span>
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </div>
      </TableCard.Root>
    </div>
  );
}
